module.exports = __webpack_public_path__ + "img/logout-line.f047d880.svg";